export const MAX_CATEGORIES = 8

export const GOOGLE_CAL_KEY = 'googleCalendarEnabled'